<template>
  <v-row class="minimart-table-footer py-2" dense>
    <ManageBaseTableFooterAddBtn @add="$emit('add')" />
    <v-col class="grow">
      <v-row class="text-center" dense>
        <v-col cols="12">
          <v-pagination
            :length="totalPageCount"
            v-model="currentPage"
            @input="updateRouteQuery('page', Number($event))"
            :total-visible="11"
        /></v-col>
        <v-col cols="12">Records {{ from }} - {{ to }} of {{ total }}</v-col>
      </v-row>
    </v-col>
    <v-col class="per-page-select">
      <span>Items Per Page</span>
      <v-select
        :value="itemsPerPage"
        @change="updateRouteQuery('per_page', Number($event))"
        :items="items"
        hide-details
        dense
        class="mr-sm-6"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import ManageBaseTableFooterAddBtn from '@/components/ManageBaseTableFooterAddBtn'
import PaginationDefaults from '@/constants/PaginationDefaults'
export default {
  name: 'ManageBaseTableFooter',
  components: { ManageBaseTableFooterAddBtn },
  data() {
    return {
      items: PaginationDefaults,
    }
  },
  methods: {
    updateRouteQuery(key, val) {
      this.$router.push({
        path: this.$route.path,
        query: { ...this.$route.query, [key]: val },
      })
    }, // updateRouteQuery
  },
  computed: {
    ...mapFields('admin', {
      totalPageCount: 'tableMeta.last_page',
      currentPage: 'tableMeta.page',
      itemsPerPage: 'tableMeta.per_page',
      from: 'tableMeta.from',
      to: 'tableMeta.to',
      total: 'tableMeta.total',
    }),
  }, // computed
}
</script>

<style>
.minimart-table-footer {
  font-size: 0.75rem;
}
.per-page-select {
  width: 100px;
  max-width: 100px;
}
</style>
